/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_500_DescriptionInputs */

const ja_error_500_description = /** @type {(inputs: Error_500_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクセスしようとしたページは表示できませんでした。`)
};

const en_error_500_description = /** @type {(inputs: Error_500_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown Error`)
};

/**
* | output |
* | --- |
* | "Unknown Error" |
*
* @param {Error_500_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const error_500_description = /** @type {((inputs?: Error_500_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_500_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_error_500_description(inputs)
	return en_error_500_description(inputs)
});